<template>
  <section class="container">
    <div class="header">
      <span class="category">{{ t('problem_category') }}</span>
      <h2>{{ t('problem_h2') }}</h2>
      <p>{{ t('problem_p') }}</p>
    </div>

    <RowCards :features="features" height="340px" />
  </section>
</template>

<script>
import RowCards from '@components/section/RowCards.vue'

export default {
  name: 'Problem',
  components: { RowCards },
  setup() {
    const features = [
      {
        icon: 'fa-solid fa-money-bill',
        color: '52, 78, 65',
        headline: 'problem_1_h',
        text: 'problem_1_p',
      },
      {
        icon: 'fa-solid fa-gamepad',
        color: '181, 23, 158',
        headline: 'problem_2_h',
        text: 'problem_2_p',
      },
      {
        icon: 'fa-solid fa-fire',
        color: '0, 119, 182',
        headline: 'problem_3_h',
        text: 'problem_3_p',
      },
      {
        icon: 'fa-solid fa-users',
        color: '42, 173, 73',
        headline: 'problem_4_h',
        text: 'problem_4_p',
      },
      {
        icon: 'fa-solid fa-up-right-and-down-left-from-center',
        color: '231, 12, 0',
        headline: 'problem_5_h',
        text: 'problem_5_p',
      },
      {
        icon: 'fa-solid fa-gauge-high',
        color: '40, 88, 26',
        headline: 'problem_6_h',
        text: 'problem_6_p',
      },
    ]

    return {
      features,
    }
  },
}
</script>
